














import { Component, Watch, Vue } from 'vue-property-decorator';
import { KonvaEventObject } from 'konva/types/Node';
import { TweenLite, gsap } from 'gsap';
import MapLabels from './MapLabels.vue';
import MapBackground from './MapBackground.vue';
import FootprintsWrapper from './FootprintsWrapper.vue';
import locations from '../data/locations';
import { getLocationById } from '../utils/locationUtils';

@Component({
  components: {
    MapLabels,
    MapBackground,
    FootprintsWrapper,
  },
})
export default class MapWrapper extends Vue {
  setCurrentEventById(id: string) {
    this.$store.dispatch('events/setCurrentEventById', id);
  }

  get currentEvent() {
    return this.$store.getters['events/getCurrentEvent'];
  }

  currentAnimation: ReturnType<typeof TweenLite.to> | null = null; // reference of most recent animation, it's needed to kill it if new dragging starts before animation ended
  minZoom = 0.4;
  maxZoom = 1.4;
  zoom = 0.5; // current zoom
  loc = {
    // location of map
    x: 0,
    y: 0,
  };

  get center() {
    // center of view on the map
    return {
      x: (window.innerWidth / 2 - this.loc.x) / this.zoom,
      y: (window.innerHeight / 2 - this.loc.y) / this.zoom,
    };
  }

  get configMap() {
    return {
      x: this.loc.x,
      y: this.loc.y,
      scale: { x: this.zoom, y: this.zoom },
      draggable: true,
    };
  }

  onWheel({ evt }: KonvaEventObject<WheelEvent>): void {
    // calculate new zoom level based on wheel scroll
    const delta = evt.deltaY;
    let zoom = this.zoom;

    if (
      (zoom < this.maxZoom || delta > 0) &&
      (zoom > this.minZoom || delta < 0)
    ) {
      //zoom *= 0.999 ** delta;
      zoom = delta < 0 ? zoom * 1.1 : zoom / 1.1;

      this.zoomTo(zoom);
    }
  }

  onDragMove({ target }: KonvaEventObject<MouseEvent>): void {
    if (this.currentAnimation) {
      this.currentAnimation.kill();
    }
    this.loc.x = target.x();
    this.loc.y = target.y();
  }

  onDragEnd(): void {
    const bgWidth = 6600;
    const bgHeight = 4751;

    const newX =
      this.center.x < window.innerWidth / (2 * this.zoom)
        ? window.innerWidth / (2 * this.zoom)
        : this.center.x > bgWidth - window.innerWidth / (2 * this.zoom)
        ? bgWidth - window.innerWidth / (2 * this.zoom)
        : this.center.x;
    const newY =
      this.center.y < window.innerHeight / (2 * this.zoom)
        ? window.innerHeight / (2 * this.zoom)
        : this.center.y > bgHeight - window.innerHeight / (2 * this.zoom)
        ? bgHeight - window.innerHeight / (2 * this.zoom)
        : this.center.y;

    if (newX !== this.center.x || newY !== this.center.y) {
      this.moveTo({ x: newX, y: newY });
    }
  }

  moveTo(newLoc: { x: number; y: number }) {
    // move center of screen to new position

    const loc = { x: this.loc.x, y: this.loc.y };

    const anim = gsap.to(loc, {
      x: window.innerWidth / 2 - newLoc.x * this.zoom,
      y: window.innerHeight / 2 - newLoc.y * this.zoom,
      duration: 1,
      ease: 'power3.out',
      onUpdate: () => {
        this.loc.x = loc.x;
        this.loc.y = loc.y;
      },
    });
    this.currentAnimation = anim;
  }

  zoomTo(newZoom: number): void {
    // zoom in or out in regard to screen center

    const zoom = { zoom: this.zoom, x: this.loc.x, y: this.loc.y };
    const oldCenter = {
      x: this.center.x,
      y: this.center.y,
    };
    const anim = gsap.to(zoom, {
      zoom: newZoom,
      x: window.innerWidth / 2 - oldCenter.x * newZoom,
      y: window.innerHeight / 2 - oldCenter.y * newZoom,
      duration: 0.6,
      ease: 'power3.out',
      onUpdate: () => {
        this.zoom = zoom.zoom;
        this.loc.x = zoom.x;
        this.loc.y = zoom.y;
      },
    });
    this.currentAnimation = anim;
  }

  @Watch('currentEvent')
  onCurrentEventChange(newEvent: { location: string }): void {
    const loc = getLocationById(locations, newEvent.location);

    if (loc) this.moveTo(loc.coords);
  }
}
